export const codePos = {
    "u": { code: 0, dx: +1, dy: +1 },
    "d": { code: 1, dx: -1, dy: +1 },
    "l": { code: 2, dx: -1, dy: -1 },
    "r": { code: 3, dx: +1, dy: -1 },
    "n": { code: -1, dx: 0, dy: 0 },
};
export const _debugNcode_w = 200;
export const debugNcode_h = 500;
export const _glyphDistancePx_canvas = 8;
//# sourceMappingURL=codePositionDefinition.js.map